module.exports = __webpack_public_path__ + "static/img/index.9de1242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/index.jpg
// module id = M7fv
// module chunks = 36